import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import PropertyResult from '../../PropertySearchPage/V2/react/PropertyResult.js';

if (document.getElementById('relatedProperties')) {
    const pse = document.getElementById('relatedProperties');
    const pid = pse.attributes['data-page-id'].value;
    const heading = pse.attributes['data-page-heading']?.value;
    const cardType = pse.attributes['data-card-type']?.value;

    const root = createRoot(pse);
    async function GetProperties() {
        const data = await fetch('/ppi/propertysearchapi/related/' + pid + '/' + (cardType != null ? cardType + '/' : ''));
        const properties = await data.json();
        const r = properties.map(x =>
            <PropertyResult key={x.Id} property={x} />
        );

        root.render(
            <StrictMode>
                {r != null && r.length > 0 &&
                    <div className="block grid-conteint fluid featuredproperties bg-lightblue">
                        <div className="grid-container">
                            <div className="relatedproperties grid-container relative">
                                <h3 className="h3 mb-4">{heading}</h3>
                                <div className="grid-x">
                                {r}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </StrictMode>
        );
    }

    GetProperties();
}
